import { useLocale } from "../i18n/context";
import { Header } from "../components/layout/Header";
import { Footer } from "../components/layout/Footer";
import { MapSidebar } from "../components/layout/MapSidebar";

export function MontavimasPage() {
  const { t } = useLocale();

  return (
    <>
      <Header />

      <div className="flex max-w-[1200px] mx-auto mt-[132px] mb-10 px-5 gap-[30px] max-md:flex-col max-md:mb-5 max-md:gap-5">
        <main
          className="flex-[2] bg-white p-10 shadow-[0_2px_10px_rgba(0,0,0,0.1)] max-md:p-5"
          dangerouslySetInnerHTML={{ __html: t.montavimasHtml }}
        />

        <MapSidebar />
      </div>

      <Footer />
    </>
  );
}
